import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './sidebar/sidebar-data';
import { NavItem } from './sidebar/nav-item/nav-item';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './header/header.component';
import { InstructorBottomNavComponent } from './instructor-bottom-nav/instructor-bottom-nav.component';
import { AuthService } from 'src/app/services/auth.service';
import { USER_ROLES } from 'src/app/config/user-roles';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';


const NO_CONTAINER_ROUTES = [
  '/school/lessons'
]

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    InstructorBottomNavComponent,
  ],
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class FullComponent implements OnInit {

  navItems = navItems;

  // Tracks which sidebar section captions (navCap) are currently expanded.
  // Purely presentational - sidebar-data.ts / permissions / routing are untouched.
  // Persisted to localStorage so the sidebar remembers what the user opened/closed
  // across refreshes. First-ever visit (nothing in storage yet) -> everything closed.
  private static readonly STORAGE_KEY = 'sidebar-expanded-caps';

  private expandedCaps = new Set<string>(this.loadExpandedCaps());

  private loadExpandedCaps(): string[] {
    if (typeof localStorage === 'undefined') return [];
    try {
      const raw = localStorage.getItem(FullComponent.STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  private saveExpandedCaps(): void {
    if (typeof localStorage === 'undefined') return;
    try {
      localStorage.setItem(
        FullComponent.STORAGE_KEY,
        JSON.stringify(Array.from(this.expandedCaps))
      );
    } catch {
      // storage unavailable/full - fail silently, in-memory state still works
    }
  }

  // Groups the existing flat navItems list into { cap, items } sections for rendering,
  // using the same navCap boundaries that already exist in sidebar-data.ts.
  get groupedNavItems(): { cap: NavItem; items: NavItem[] }[] {
    const groups: { cap: NavItem; items: NavItem[] }[] = [];
    let current: { cap: NavItem; items: NavItem[] } | null = null;

    for (const item of this.navItems) {
      if (item.navCap) {
        current = { cap: item, items: [] };
        groups.push(current);
      } else if (current) {
        current.items.push(item);
      }
    }

    return groups;
  }

  isCapExpanded(cap?: string): boolean {
    return !!cap && this.expandedCaps.has(cap);
  }

  toggleCap(cap?: string): void {
    if (!cap) return;
    if (this.expandedCaps.has(cap)) {
      this.expandedCaps.delete(cap);
    } else {
      this.expandedCaps.add(cap);
    }
    this.saveExpandedCaps();
  }

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;

  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  isFullWidth = false;


  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isInstructor(): boolean {
    return this.authService.userSig()?.role === USER_ROLES.INSTRUCTOR;
  }

  get isInstructorRoute(): boolean {
    const url = this.router.url;
    return url.startsWith('/instructor') || (this.isInstructor && url.startsWith('/profile'));
  }

  constructor(private breakpointObserver: BreakpointObserver, private navService: NavService, private router: Router, private authService: AuthService) {

    this.htmlElement = document.querySelector('html')!;
    this.htmlElement.classList.add('light-theme');
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes

        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
  }

  ngOnInit(): void {
    // this.router.events
    //   .pipe(
    //     filter(
    //       (event): event is NavigationEnd => event instanceof NavigationEnd
    //     )
    //   )
    //   .subscribe((event) => {
    //     this.isFullWidth = NO_CONTAINER_ROUTES.includes(event.urlAfterRedirects);
    //   });
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }
}
